import React from "react";
import "animate.css";

function DeliveryInfo() {
  return (
    <section className="bg-gray-100 py-16 px-6 animate__animated animate__fadeIn mt-10">
      <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-xl p-8 md:p-12 mt-6 sm:mt-10 md:mt-20">
        
        {/* Заголовок */}
        <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-8 -mt-4">
          Жеткирүү жана орнотуу
        </h2>

        {/* Бишкек */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-[#2A254B] mb-4">
            🏙 Бишкек шаарында
          </h3>

          <ul className="space-y-3 text-gray-700">
            <li className="flex gap-3">
              <span className="text-green-600 text-lg">✔</span>
              <span>
                <strong>Жеткирүү, чогултуу жана орнотуу</strong> — толугу менен БЕКЕР
              </span>
            </li>
            <li className="flex gap-3">
              <span className="text-green-600 text-lg">✔</span>
              <span>Жеткирүү убактысы алдын ала макулдашылат</span>
            </li>
          </ul>
        </div>

        {/* Регионы */}
        <div className="mb-8">
          <h3 className="text-xl font-semibold text-[#2A254B] mb-4">
            🚚 Кыргызстан боюнча региондорго
          </h3>

          <ul className="space-y-3 text-gray-700">
            <li className="flex gap-3">
              <span className="text-[#2A254B] text-lg">•</span>
              <span>Жеткирүү — кошумча акы менен</span>
            </li>
            <li className="flex gap-3">
              <span className="text-green-600 text-lg">✔</span>
              <span>
                <strong>Чогултуу жана орнотуу</strong> — БЕКЕР
              </span>
            </li>
            <li className="flex gap-3">
              <span className="text-[#2A254B] text-lg">•</span>
              <span>Алыстагы аймактарга курьер аркылуу жөнөтүлөт</span>
            </li>
          </ul>
        </div>

        {/* Сроки */}
        <div className="bg-gray-50 border-l-4 border-[#2A254B] p-5 rounded-lg">
          <h3 className="text-xl font-semibold text-gray-800 mb-3">
            ⏳ Мөөнөт
          </h3>

          <ul className="space-y-3 text-gray-700">
            <li className="flex gap-3">
              <span className="text-[#2A254B]">•</span>
              <span>
                Буйрутма толук төлөнгөндөн кийин, жеткирүү
                <strong> 15–20 иш күндүн </strong>
                ичинде аткарылат
              </span>
            </li>
            <li className="flex gap-3">
              <span className="text-green-600">✔</span>
              <span>Биздин кызматтарыбыз менен ыңгайлуулукту сезиңиз 😊</span>
            </li>
          </ul>
        </div>

        {/* Контакт */}
        <p className="text-center text-gray-600 mt-8">
          Кошумча маалымат үчүн биз менен байланышыңыз
        </p>

      </div>
    </section>
  );
}

export default DeliveryInfo;
